import { type CSSProperties, type ReactNode } from "react";
import "./index.css";
import { clsx } from "clsx";
import { Typography } from "../Typography";
import { Skeleton } from "../Skeleton";
import type { ILabelValueProps } from "./types";
import { CopyIconButton } from "../CopyButton";
import { cloneWithClassName } from "../../utils";

const renderContent = (
  content: ReactNode,
  className: string,
  style?: CSSProperties,
) => {
  return (
    cloneWithClassName(content, className, style) || (
      <Typography
        as="div"
        variant="headline"
        text={content}
        style={style}
        className={className}
      />
    )
  );
};

export const LabelValue = ({
  label,
  value,
  direction = "row",
  labelWidth,
  canCopy = false,
  copyText,
  loading,
  className,
  onRenderValue,
  gap,
  fullWidth,
}: ILabelValueProps) => {
  const rootClass = clsx(
    "label-value",
    `label-value--${direction}`,
    gap && `label-value--gap-${gap}`,
    fullWidth && `label-value--fullWidth`,
    className,
  );
  const copyContent: string = copyText || `${value}`;

  return (
    <div className={rootClass}>
      {renderContent(label, "label-value__label", {
        minWidth: labelWidth,
        maxWidth: labelWidth,
      })}
      <div className="label-value__value-wrapper">
        {loading ? (
          <Skeleton width="12.5rem" height="1.5rem" />
        ) : onRenderValue ? (
          onRenderValue()
        ) : (
          <>
            {renderContent(value, "label-value__value")}
            {canCopy && (
              <div className="label-value__copyIcon">
                <CopyIconButton
                  size="xs"
                  variant="filled"
                  color="layer1"
                  copyContent={copyContent}
                  className="label-value__copyIcon-button"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
